import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.components.WorkflowWizardPopup.UsersStep', {
    title: 'Add your teammates here to assign them as Approvers or Requesters later',
    alert: 'We won’t send any notifications to them at this point; you can invite them to start using ApprovalMax later.',
    description:
        'Enter the email addresses of the users you’d like to add. You can enter multiple emails separeted by comma, semicolon, or whitespace.',
});
